import { Notify } from 'quasar';

export function useNotifications() {
  const notify = (type, message) => {
    Notify.create({
      type,
      message,
      position: 'top',
      timeout: 3000
    });
  };

  return {
    notifySuccess: (message) => notify('positive', message),
    notifyError: (message) => notify('negative', message),
    notifyWarning: (message) => notify('warning', message),
    notifyInfo: (message) => notify('info', message),
  };
}

